var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line-item-customizations"},[_c('v-link',{staticClass:"line-item-customizations__option-link",attrs:{"href":_vm.previewImage,"target":"_blank","label":_vm.$t('view_attached_photo')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }